import script from "./RedesignHelpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignHelpModal.vue?vue&type=script&setup=true&lang=js"

import "./RedesignHelpModal.vue?vue&type=style&index=0&id=6ab41e6d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab41e6d"]])

export default __exports__